import { Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import { ModalConfig } from '../modal-config';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { CountryService } from 'src/app/_services/country.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ParentService } from 'src/app/user-management/_services/parent.service';
import { SnackbarService } from 'src/app/_services/snackBar.service';
import { SnackBarErrorComponent } from 'src/app/components/snack-bar-error/snack-bar-error.component';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { GradeService } from 'src/app/school-management/_services/grades.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ControlQrService } from 'src/app/_services/control-qr.service';
import { ControlActivationService } from 'src/app/_services/control-activation.service';
import { ModalService } from '../modal.service';
import { ErrorMsgService } from '../../error-msg/error-msg.service';
declare var $: any;

@Component({
  selector: 'app-assistant-modal',
  templateUrl: './assistant-modal.component.html',
  styleUrls: ['./assistant-modal.component.scss']
})
export class AssistantModalComponent {
  @Input() config!: ModalConfig;
  @Input() lang: string;
  // the modal's own file input — never look it up by id, other components on the
  // same page use the same id and getElementById would hand us theirs
  @ViewChild('fileUploadInput') fileUploadInput: ElementRef<HTMLInputElement>;
  addAssistantForm: UntypedFormGroup;

  loading:boolean = false;

  latitude: number;
  longitude: number;
  address: string;
  mapControls;
  mapView = '';

  countries = [];
  relatedStudents = [];
  kids = [];
  helpers = [];

  completedProfile: boolean;
  assistant;
  assistantId: number;
  assistantName: string;
  assistantActivation: boolean;

  imageFile;
  selectedImage;
  image;

  showedNumber: number;

  tableControls: any = { data: [] };

  constructor(
    // private mapsAPILoader: MapsAPILoader,
    private _snackBar: MatSnackBar,
    private ngZone: NgZone,
    private dataService: DataService,
    private countryService: CountryService,
    private translate: TranslateService,
    private parentService: ParentService,
    private snackbarService: SnackbarService,
    private studentService: StudentService,
    private gradesService: GradeService,
    private globalService: GlobalService,
    private qrControl: ControlQrService,
    private controlActivation: ControlActivationService,
    private modalService: ModalService,
    private errorMsgService: ErrorMsgService,
    
  ) { }

  ngOnInit() {
    this.setMapView('init');
    // lat long of school
    this.initLatLng();
    this.initFormFields();
    this.getCountries();
    if (this.config.mode != 'add') {
      this.setEditValues();
    }
    this.dataService.getRowsNumberShown().subscribe(res => {
      this.showedNumber = res
    })
  }

  initFormFields() {
    this.addAssistantForm = new UntypedFormGroup({
      name: new UntypedFormControl('', [Validators.required]),
      national_id: new UntypedFormControl('', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]),
      gender: new UntypedFormControl(''),
      type: new UntypedFormControl('', Validators.required),
      country_code: new UntypedFormControl('', Validators.required),
      phone: new UntypedFormControl('', [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')])
    })
  }

  setEditValues() {
    if (this.config?.data) {
      this.assistant = this.config?.data;
      this.image = environment.img_url + this.config?.data?.image_path;
      this.completedProfile = this.config?.data?.is_completed_profile === 1 ? true : false;
      this.assistantId = this.config?.data?.id;
      this.assistantName = this.config?.data?.name;
      this.assistantActivation = this.config?.data?.schools[0]?.pivot?.is_active === 1 ? true : false;
      this.relatedStudents = this.config?.data?.students;
      this.helpers = this.config?.data?.helpers;

      for (const i in this.addAssistantForm?.value) {
        this.addAssistantForm.controls[i].setValue(this.config?.data[i])
      }
      this.addAssistantForm?.controls['country_code'].setValue(this.config?.data?.country_code)
      this.addAssistantForm?.controls['phone'].setValue(this.config?.data?.phone)
      this.addAssistantForm?.controls['email'].setValue(this.config?.data?.email)
      this.config?.data?.gender == "male" ? this.addAssistantForm?.controls.type.setValue('father') :
        this.addAssistantForm?.controls.type.setValue('mother');
      // if(this.completedProfile){
      //   this.addAssistantForm.get('country_code').disable();
      // }
      this.mapKidsArray(this.relatedStudents)
    }
  }

  setMapView(viewCycle) {
    this.mapView = viewCycle == 'init' ? 'add-parent' : 'add-parent-destroyed';
  }

  initLatLng() {
    this.latitude = this.config?.data?.lat ? this.config?.data?.lat : parseFloat(localStorage.getItem('schoolLat'));
    this.longitude = this.config?.data?.long ? this.config?.data?.long : parseFloat(localStorage.getItem('schoolLong'));
    this.address = this.config?.data?.address;
    this.initMapControls();
  }

  initMapControls() {
    this.mapControls = {
      mapPoint: {
        lat: this.latitude,
        long: this.longitude,
      }
    }
  }

  getCountries() {
    this.countries = this.countryService.countries;
  }

  getValidationError(control: string) {
    let errorMSG;
    if (this.addAssistantForm.controls[control].errors) {
      switch (control) {
        case 'name':
          errorMSG = this.addAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.name-required') :
            this.addAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.name-exists')
              : this.translate.instant('edit-assistant.name-valid');
          break;
        case 'national_id':
          errorMSG = this.addAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.id-required') :
            this.addAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.id-exists')
              : this.translate.instant('edit-assistant.id-valid');
          break;

        case 'phone':
          errorMSG = this.addAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.phone-required') :
            this.addAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.phone-exists')
              : this.translate.instant('edit-assistant.phone-valid');
          break;

        case 'email':
          errorMSG = this.addAssistantForm.controls[control].errors.required ? this.translate.instant('edit-assistant.email-required') :
            this.addAssistantForm.controls[control].errors.repeat ? this.translate.instant('edit-assistant.email-exists')
              : this.translate.instant('edit-assistant.email-valid');
          break;
        default:
          break;
      }
    }
    return errorMSG;
  }

  getImage(url) {
    return environment.img_url + url;
  }

  changeAssistantProfile() {
    const fileUpload = this.fileUploadInput?.nativeElement;
    if (!fileUpload) {
      return;
    }
    // clearing the value first so re-picking the same file still fires `change`
    fileUpload.value = null;
    fileUpload.click();
  }

  onFileSelected(file: FileList) {
    const picked = file?.item(0);
    if (!picked) {
      return;
    }
    // the upload payload and the preview are set together, so they can never diverge
    this.imageFile = picked;
    this.selectedImage = picked;
    const reader = new FileReader();
    reader.onload = (event: any) => {
      this.image = event.target.result;
    };
    reader.readAsDataURL(picked);
  }

  showQR() {
    this.qrControl.setParentData(this.assistant, 'single');
    $('#qrModal').modal("show");
  }


  mapEventHandle(event) {
    switch (event.type) {
      case "updateAdress":
        this.address = event.data;
        this.latitude = event.lat;
        this.longitude = event.lng;
        break;
    }
  }

  changeActivation() {
    let body = { 'noOfShownRows': this.showedNumber, 'type': '', 'userName': this.assistantName, 'userId': this.assistantId, 'state': !this.assistantActivation, 'event': '' }
    this.controlActivation.setToggledUSer(body);
    $("#confirmModal").modal("show");
  }


  sanitizeDataBeforeSendToServer(): void {
    let assistantGender = this.addAssistantForm.get('gender');

    if ((assistantGender.value as string)?.trim() === '' || assistantGender.value == "noParentGender" || assistantGender.value == null) {
      delete this.addAssistantForm.value['gender'];
    }
  }

  // add student
  saveAssistant() {
    this.sanitizeDataBeforeSendToServer();
    const formData = new FormData();
    if (this.imageFile) {
      formData.append('image', this.imageFile);
    }
    for (const i in this.addAssistantForm.value) {
      formData.append(i, this.addAssistantForm.value[i])
    }
    if (this.latitude !== null && this.longitude !== null) {
      formData.append('lat', this.latitude.toString())
      formData.append('long', this.longitude.toString())
    }
    formData.append('address', this.address);

    // updating parent
    this.parentService.updateParent(this.assistantId, formData).subscribe(res => {
      this.updateAllUsersObservable();
      this.closeModalHandler();
    },
      (error) => {
        Object.keys(error.error.errors).map(element => {
          this.addAssistantForm.controls[element].setErrors({ 'repeat': true });
          this.addAssistantForm.controls[element].markAsTouched();
        })
      })
  }

  updateAllUsersObservable() {
    this.dataService.getUsers$().subscribe(res => {
      this.dataService.setUsers$(res);
    })
  }


  setTableData() {
    this.tableControls = {
      selection: false,
      paging: false,
      view: 'list',
      title: 'edit-assistant.kids',
      totalTitle: 'table-view.total-titles.students',
      columns: [
        {
          name: "",
          sort: false,
          type: "image",
          source: "student_image"
        },
        {
          name: this.translate.instant('edit-assistant.student-name'),
          sort: false,
          type: "string",
          source: "name"
        },
        {
          name: this.translate.instant('edit-assistant.grade'),
          sort: false,
          type: "string",
          source: "grade"
        },
        {
          name: this.translate.instant('edit-assistant.class'),
          sort: false,
          type: "string",
          source: "class"
        },
        {
          name: this.translate.instant('edit-assistant.national-id'),
          sort: false,
          type: "string",
          source: "national_id"
        },
        {
          name: this.translate.instant('edit-assistant.student-activate'),
          sort: false,
          type: "non-pivot-activation",
        },
        {
          name: this.translate.instant('edit-assistant.student-delete'),
          sort: false,
          type: "deleteIcon",
        }
      ],
      data: this.kids
    }
  }

  tableEventHandeler(event) {
    switch (event.action) {
      case 'activationChanged':
        this.toggleKidActivation(event.target.data , this.config.data.id)
        break;
      case 'DeleteIconClicked':
        this.deleteKid(event.target.data.id , this.config.data.id)
        break;
      default:
        break;
    }
  }

  closeModalHandler() {
    this.dataService.setRowsNumberShown(this.showedNumber);
    this.modalService.closeModal();
  }

  mapKidsArray(kidsArray: any) {
    this.kids = kidsArray.map(kid => (
      {
        student_image: kid.image_path,
        name: kid.name,
        grade: kid.class?.grade.name,
        class: kid.class?.name,
        national_id: kid.national_id,
        id: kid.id,
        is_active: kid?.pivot?.pick_type
      }
    ));
    this.setTableData();
  }

  deleteKid(studentId: string, assistant_id: any): void {
    this.loading = true;
    const index = this.kids.findIndex(kid => kid.id === studentId);
    if (index !== -1) {
      const deletedUser = this.kids.splice(index, 1)[0]; // Optimistically remove

      this.parentService.removeStudentAssignationFromAssistant(assistant_id, studentId).subscribe({
        next: () => {
          // Success: Refresh the table
          this.setTableData();
          this.loading = false;
        },
        error: (err) => {
          this.kids.splice(index, 0, deletedUser); // Revert on error
          this.setTableData();
          this.errorMsgService.setMessage(err?.error?.message);
          this.loading = false;
        }
      });
    }
  }


  toggleKidActivation(student: any , assistantId:any): void {
    this.loading = true;
    let body: any = {}
    const previousState = student.is_active; // Save the previous state
    student.is_active = previousState === 'none' ? 'always' : 'none'; // Optimistic update
    body = {
      student_id: student.id, // required
      pick_type: student.is_active
    }
    this.parentService.toogleStudentActivationFromAssistant(assistantId, body).subscribe({
      next: () => {
        // Success: Refresh the table
        this.setTableData();
        this.loading = false;
      },
      error: (err) => {
        student.is_active = previousState; // Revert on error
        this.setTableData();
        this.errorMsgService.setMessage(err?.error?.message);
        this.loading = false;
      }
    });
  }
}
